var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150.02 150.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Element 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75,0a75,75,0,1,0,75,75A75,75,0,0,0,75,0Zm.6,122.18h0a47.66,47.66,0,0,1-22.74-5.8L27.62,123l6.76-24.65a47.59,47.59,0,1,1,41.23,23.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.63,35A39.56,39.56,0,0,0,42.11,95.61l.94,1.5-4,14.59,15-3.93,1.44.86a39.53,39.53,0,0,0,20.13,5.51h0a39.56,39.56,0,0,0,0-79.11ZM98.89,91.57c-1,2.78-5.74,5.31-8,5.65a16.27,16.27,0,0,1-7.48-.47,69,69,0,0,1-6.78-2.5c-11.93-5.15-19.72-17.16-20.31-18S51.43,69.85,51.43,64a13.31,13.31,0,0,1,4.16-9.91,4.38,4.38,0,0,1,3.17-1.49c.8,0,1.59,0,2.28,0s1.71-.28,2.68,2,3.37,8.23,3.66,8.83a2.17,2.17,0,0,1,.1,2.08,33.15,33.15,0,0,1-3,4.06c-.53.66-1.22,1.24-.52,2.43a35.76,35.76,0,0,0,6.61,8.23,32.45,32.45,0,0,0,9.56,5.9c1.19.6,1.89.5,2.58-.29s3-3.47,3.76-4.66,1.59-1,2.68-.6,6.94,3.27,8.12,3.87,2,.89,2.28,1.39S99.88,88.79,98.89,91.57Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhatsapp);
export default __webpack_public_path__ + "static/media/icon_whatsapp.e972f0a18096713415d94637c091e05d.svg";
export { ForwardRef as ReactComponent };